var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.25V0.25H5V4.75H0.5V13.75H15.5V6.25H11ZM6.5 1.75H9.5V12.25H6.5V1.75ZM2 6.25H5V12.25H2V6.25ZM14 12.25H11V7.75H14V12.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.282de5d23c6f1140e61f2fceae976cb6.svg";
export { ForwardRef as ReactComponent };